/** Каталоги строк и форматирование. Общие для приложения, бота и API. */

import { ru } from './locales/ru.ts';
import { en } from './locales/en.ts';
import type { Catalog } from './locales/types.ts';

export type { Catalog };
export { ru, en };
export * from './format.ts';

export const SUPPORTED_LANGS = ['ru', 'en'] as const;
export type Lang = (typeof SUPPORTED_LANGS)[number];
export const FALLBACK_LANG: Lang = 'en';

export const catalogs: Record<Lang, Catalog> = { ru, en };

/** i18next-совместимая карта ресурсов. */
export const resources = {
  ru: { translation: ru },
  en: { translation: en },
} as const;

/**
 * Язык из Telegram. Всё, кроме русского, ведём на английский: половина
 * каталога на третьем языке хуже, чем честный английский целиком.
 */
export function pickLang(languageCode: string | undefined): Lang {
  return languageCode?.toLowerCase().startsWith('ru') === true ? 'ru' : 'en';
}
